// extracted by mini-css-extract-plugin
export default {"segmentCell":"SegmentCell_segmentCell__B58R4","title":"SegmentCell_title__e+PSj","more":"SegmentCell_more__7cdOK","linkToSegment":"SegmentCell_linkToSegment__lfPD0"};